module.exports = __webpack_public_path__ + "static/media/art&culture.f9d3e691.jpg";